import { render, staticRenderFns } from "./UiInputDate.vue?vue&type=template&id=2a153ce2&scoped=true"
import script from "./UiInputDate.vue?vue&type=script&lang=js"
export * from "./UiInputDate.vue?vue&type=script&lang=js"
import style0 from "./UiInputDate.vue?vue&type=style&index=0&id=2a153ce2&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a153ce2",
  null
  
)

export default component.exports